import React from "react";
import SearchForm from "../../components/SearchForm";
import SelectCard from "../../components/SelectCard";

import { Link } from "react-router-dom";
import img1 from "../../assets/img/product/1.png";
import img2 from "../../assets/img/product/2.png";
import img3 from "../../assets/img/product/3.png";
import img4 from "../../assets/img/product/4.png";
import { BinanceIcon, Star } from "../../icon/IconTheme";
const Collection = () => {
	return (
		<>
			<div className="filter-top-bar filter-top-bar-2">
				<SearchForm />
				<div className="select-grp select-grp-2 ms-auto">
					<SelectCard data={data} />
				</div>
			</div>
			<h4 className="section-title">3 Results</h4>
			<div className="row g-2 gx-sm-3 gy-sm-4 gy-3">
				{data2 &&
					data2.map((item, i) => (
						<CollectionItem {...item} key={i} serial={i} />
					))}
			</div>
		</>
	);
};
export const CollectionItem = ({
	img,
	title,
	price,
	bidder,
	rating,
	index,
	setIndex,
	setModalOpen,
	serial,
	text,
	collection,
	status,
}) => {
	console.log(status);
	return (
		<div className="col-6 col-lg-4 col-xl-3">
			<div className="item-card" style={{ marginBottom: "3px" }}>
				<Link to="/collection/showcase" className="absolute-link"></Link>
				<div className="item-card-img">
					<img src={img} alt="" />
				</div>
				<div className="item-card-content">
					<div
						className="d-flex flex-wrap justify-content-between mb-3"
						style={{ gap: "5px" }}
					>
						{title && <h4 className="subtitle m-0">{title}</h4>}
						<ul className="holding-tag">
							<li>
								<Link
									to="#"
									className={status === "forsale" ? "active" : ""}
								>
									For Sale
								</Link>
							</li>
							<li>
								<Link
									to="#"
									className={status === "holding" ? "active" : ""}
								>
									Holding
								</Link>
							</li>
						</ul>
					</div>
					<div className="text">{text}</div>
					<div className="d-flex flex-wrap justify-content-between">
						{collection && (
							<div className="mt-3">
								<div className="subtext">Block Number</div>
								<div className="collection">{collection}</div>
							</div>
						)}
						<div className="price text-end mt-3">
							<div className="subtext">Price</div>
							<BinanceIcon /> {price}
						</div>
					</div>
					<div className="rating" style={{ marginTop: "12px" }}>
						<Star />
						<Star />
						<Star />
						<Star />
					</div>
				</div>
			</div>
		</div>
	);
};
const data = [
	{
		option: "Recently Listed",
		value: "1",
	},
	{
		option: "Last Month",
		value: "1",
	},
	{
		option: "Last Year",
		value: "1",
	},
	{
		option: "Archived",
		value: "1",
	},
];
const data2 = [
	{
		img: img3,
		title: "Hashima 3",
		collection: "25,886,419",
		rating: "0",
		status: "holding",
		price: "0.21",
		text: `Pata Yeye it's one of the most soldierly of all. Not only due to its fearful combat abilities, but also due to its creativity on the battlefield; it has created unbelievable martial tactics that defy logic. It is said that one of Pata Yeye soldiers can easily take out ten enemies and willing to risk their own lives to assure`,
	},
	{
		img: img1,
		title: "Hashima 1",
		collection: "25,886,419",
		rating: "0",
		status: "forsale",
		price: "0.21",
		text: `Pata Yeye it's one of the most soldierly of all. Not only due to its fearful combat abilities, but also due to its creativity on the battlefield; it has created unbelievable martial tactics that defy logic. It is said that one of Pata Yeye soldiers can easily take out ten enemies and willing to risk their own lives to assure`,
	},
	{
		img: img2,
		title: "Hashima 2",
		collection: "25,886,419",
		rating: "0",
		status: "holding",
		price: "0.21",
		text: `Pata Yeye it's one of the most soldierly of all. Not only due to its fearful combat abilities, but also due to its creativity on the battlefield; it has created unbelievable martial tactics that defy logic. It is said that one of Pata Yeye soldiers can easily take out ten enemies and willing to risk their own lives to assure`,
	},
	{
		img: img4,
		title: "Hashima 4",
		collection: "25,886,419",
		rating: "0",
		status: "forsale",
		price: "0.21",
		text: `Pata Yeye it's one of the most soldierly of all. Not only due to its fearful combat abilities, but also due to its creativity on the battlefield; it has created unbelievable martial tactics that defy logic. It is said that one of Pata Yeye soldiers can easily take out ten enemies and willing to risk their own lives to assure`,
	},
];
export default Collection;
